import { render, staticRenderFns } from "./SliderContainer.vue?vue&type=template&id=6312f471&scoped=true&"
import script from "./SliderContainer.vue?vue&type=script&lang=js&"
export * from "./SliderContainer.vue?vue&type=script&lang=js&"
import style0 from "./SliderContainer.vue?vue&type=style&index=0&id=6312f471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312f471",
  null
  
)

export default component.exports